import { useTranslation } from 'react-i18next'
import { ReactNode } from 'react'

import { AdvancedDomainCheck } from '../utils/getGroupedFraudChecks'

import { Badge, CardContent, Flex } from '@percent/lemonade'
import { formatGeolocation } from '@percent/admin-dashboard/common/utility/formatGeolocation'

function ConditionalCardContent({ title, children }: { title: string; children: ReactNode }) {
  if (!children) return null

  return <CardContent title={title}>{children}</CardContent>
}

export function FraudCheckDomainCheckInfo({ data, checkName }: AdvancedDomainCheck) {
  const { t } = useTranslation()

  if (checkName === 'who_is_check') {
    return (
      <>
        <CardContent title={t('typography.source')}>
          {Array.isArray(data.source) ? (
            <Flex wrap="wrap" gap={4}>
              {data.source.map(source => (
                <Badge variant="default" key={source}>
                  {source}
                </Badge>
              ))}
            </Flex>
          ) : (
            <Badge variant="default">{data.source}</Badge>
          )}
        </CardContent>
        <ConditionalCardContent title={t('typography.registrationDate')}>{data.registeredDate}</ConditionalCardContent>
        <ConditionalCardContent title={t('typography.domainAge')}>{data.domainAge}</ConditionalCardContent>
        <ConditionalCardContent title={t('typography.registrar')}>{data.registrar}</ConditionalCardContent>
      </>
    )
  }

  if (checkName === 'geolocation_check') {
    return (
      <>
        <ConditionalCardContent title={t('typography.location')}>
          {formatGeolocation(data.location)}
        </ConditionalCardContent>
        <ConditionalCardContent title={t('typography.ip')}>{data.ip}</ConditionalCardContent>
        <ConditionalCardContent title={t('typography.isp')}>{data.isp}</ConditionalCardContent>
        <ConditionalCardContent title={t('typography.asn')}>{data.asn}</ConditionalCardContent>
      </>
    )
  }

  return null
}
